export default __webpack_public_path__ + "static/media/tick.c0600b7d.svg";